import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//工作量相关API

const teachingPlan = {
	courseConfirm: {
		queryList: config => createAPI('/courseConfirm/queryList', 'post', config),
        deptOption: config => createAPI('/courseConfirm/deptOption', 'post', config),
        majorOption: config => createAPI('/courseConfirm/majorOption', 'post', config),
        gradeOption: config => createAPI('/courseConfirm/gradeOption', 'post', config),
        auditOption: config => createAPI('/courseConfirm/auditOption', 'post', config),
        queryTeachingProgress: config => createAPI('/courseConfirm/queryTeachingProgress', 'post', config),
        saveCourseConfirm: config => createAPI('/courseConfirm/saveCourseConfirm', 'post', config),
        submitCourseConfirm: config => createAPI('/courseConfirm/submitCourseConfirm', 'post', config),
        updateAuditState: config => createAPI('/courseConfirm/updateAuditState', 'post', config),
        queryAuditFlow: config => createAPI('/courseConfirm/queryAuditFlow', 'post', config),

        queryChangeTeachingProgress: config => createAPI('/courseConfirm/queryChangeTeachingProgress', 'post', config),
        audit: config => createAPI('/courseConfirm/audit', 'post', config),
        updateAuditState_jxjcbg: config => createAPI('/courseConfirm/updateAuditState_jxjcbg', 'post', config),
        saveModCourseConfirm: config => createAPI('/courseConfirm/saveModCourseConfirm', 'post', config),
        checkCurTime: config => createAPI('/courseConfirm/checkCurTime', 'post', config),
	},
    teachingCoursePlan: {
        list: config => createAPI('/teachingCoursePlan/list', 'post', config),
        queryTree: config => createAPI('/teachingCoursePlan/queryTree', 'post', config),
        baseParam: config => createAPI('/teachingCoursePlan/baseParam', 'post', config),
        classFixed: config => createAPI('/teachingCoursePlan/classFixed', 'post', config),
        initOption: config => createAPI('/teachingCoursePlan/initOption', 'post', config),
		courseOption: config => createAPI('/teachingCoursePlan/courseOption', 'post', config),
        saveRec: config => createAPI('/teachingCoursePlan/saveRec', 'post', config),
        checkDelSKJH: config => createAPI('/teachingCoursePlan/checkDelSKJH', 'post', config),
        delRec: config => createAPI('/teachingCoursePlan/delRec', 'post', config),
        submit: config => createAPI('/teachingCoursePlan/submit', 'post', config),
        updateAuditState: config => createAPI('/teachingCoursePlan/updateAuditState', 'post', config),
        gradeOption: config => createAPI('/teachingCoursePlan/gradeOption', 'post', config),
        deptOption: config => createAPI('/teachingCoursePlan/deptOption', 'post', config),
        majorOption: config => createAPI('/teachingCoursePlan/majorOption', 'post', config),
        classOption: config => createAPI('/teachingCoursePlan/classOption', 'post', config),
        siteOption: config => createAPI('/teachingCoursePlan/siteOption', 'post', config),
        majorSearchOption: config => createAPI('/teachingCoursePlan/majorSearchOption', 'post', config),
        classSearchOption: config => createAPI('/teachingCoursePlan/classSearchOption', 'post', config),
        exportSkjh : config => createAPI('/teachingCoursePlan/exportSkjh', 'post', config),
        importSkjh: config => createAPI('/teachingCoursePlan/importSkjh', 'post', config),
        checkEditInfo: config => createAPI('/teachingCoursePlan/checkEditInfo', 'post', config),
        courseOption_multi: config => createAPI('/teachingCoursePlan/courseOption_multi', 'post', config),
        saveTeachingPlanSet: config => createAPI('/teachingCoursePlan/saveTeachingPlanSet', 'post', config),
    },
};


export default teachingPlan;



// WEBPACK FOOTER //
// ./src/api/modules/teachingPlan.js